import $ from 'jquery';
import RevealWhenVisible from '../../components/reveal-when-visible';
import SliderWithPagination from '../../components/slider-with-pagination';
import VideoModalButton from '../../components/video-modal-button';
import Structure from './components/structure';
import FlavourVariantsSlider from './components/flavour-variants-slider';
import ContentSameSize from '../../core/components/content-same-size';
import ScrollToByUrl from '../../core/components/scroll-to-by-url';
import AnchorHashScrollTo from '../../core/components/anchor-hash-scroll-to';
import ProductVariantColorSelect from '../../components/product-variant-color-select';
import ProductVariantColorSelectClick from '../../components/product-variant-color-select-click';
import DisableElementsOnLeadsApiError from './components/disable-elements-on-leads-api-error';
import StickyBar from '../../components/sticky-bar';
import ProductColorSelect from '../../components/product-color-select';
import FloatingMessage from '../../components/floating-message';
import SimpleAjaxForm from './components/simple-ajax-form';
import CircledBackgroundSlider from './components/circled-background-slider';
import InlineVideo from '../../components/inline-video';
import ResponsiveVideo from '../../components/responsive-video';
import MilestoneSlider from '../discover-iqos/components/milestone-slider';
import DropdownSelect from '../../components/dropdown-select';
import Collapse from '../../components/collapse';
import ColoredHeaderCompareTable from './components/colored-header-compare-table';
$(() => {
    RevealWhenVisible.init();
    InlineVideo.init();
    ResponsiveVideo.init();
    SliderWithPagination.init();
    VideoModalButton.init();
    Structure.init();
    FlavourVariantsSlider.init();
    ContentSameSize.init();
    ScrollToByUrl.init();
    AnchorHashScrollTo.init();
    ProductVariantColorSelect.init();
    ProductVariantColorSelectClick.init();
    ProductColorSelect.init();
    DisableElementsOnLeadsApiError.init();
    StickyBar.init();
    FloatingMessage.init();
    SimpleAjaxForm.init();
    CircledBackgroundSlider.init();
    MilestoneSlider.init();
    DropdownSelect.init();
    Collapse.init();
    ColoredHeaderCompareTable.init();
});
